import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import classes from './TariffText.module.scss';
import { getActiveSubscriptionPeriod, getAnniversaryPeriod } from '@utils/getActiveSubscriptionPeriod';
import { useSelector } from 'react-redux';
import { anniversarySelector, isProlongationAvailableSelector, isProlongationAvailableSelectorAnniversary, netariffSelector, paymentStatusesSelector, subscriptionSelector, subscriptionStatusSelector, } from '@models/subscription/selectors';
import { getSubscriptionStatuses } from '@utils/getSubscriptionStatuses';
const TariffText = ({ isError, className }) => {
    const subscription = useSelector(subscriptionSelector);
    const status = useSelector(subscriptionStatusSelector);
    const { isTrialPeriod } = useSelector(paymentStatusesSelector);
    const isNetariff = useSelector(netariffSelector);
    const isAnniversary = useSelector(anniversarySelector);
    const isProlongationAvailable = useSelector(isProlongationAvailableSelector);
    const isProlongationAvailableAnniversary = useSelector(isProlongationAvailableSelectorAnniversary);
    const { remainingDays, price, nextTarifficationDate, tariffPlan } = subscription;
    const { isSubscriptionSuspended } = getSubscriptionStatuses(status);
    const withoutChild = !subscription?.msisdnChild;
    const commonTariffText = getActiveSubscriptionPeriod({
        isSuspended: isSubscriptionSuspended,
        isTrialPeriod,
        remainingDays,
        price,
        nextTarifficationDate,
        withoutChild,
        isNetariff,
        currentPlan: tariffPlan,
        isProlongationAvailable,
        isAnniversary,
    });
    const anniversaryTariffText = getAnniversaryPeriod(remainingDays);
    const tariffText = isAnniversary && !isProlongationAvailableAnniversary ? anniversaryTariffText : commonTariffText;
    const tariffTextClasses = classNames(classes.tariffText, className, {
        [classes.error]: isError,
    });
    return _jsx("p", { className: tariffTextClasses, children: tariffText });
};
export default TariffText;
